/** Учитывается только самый низкий явно выбранный уровень, вышестоящие не разворачиваются */

import { MmMonitoringLevel } from '../types/enums';
import { MmTaskFilters } from '../types/dto';

/** 0 и -1 в селектах — «Все» / «Не выбрано», в счётчик явного выбора не входят. */
function isExplicitId(id: number): boolean {
  return id !== 0 && id !== -1;
}

function explicitCount(list: number[]): number {
  if (!list || !list.length) {
    return 0;
  }

  let count = 0;

  for (let i = 0; i < list.length; i += 1) {
    if (isExplicitId(list[i])) {
      count += 1;
    }
  }

  return count;
}

function explicitIds(list: number[]): number[] {
  if (!list || !list.length) {
    return [];
  }

  const result: number[] = [];

  for (let i = 0; i < list.length; i += 1) {
    if (isExplicitId(list[i])) {
      result.push(list[i]);
    }
  }

  return result;
}

export function toExplicitMonitoringFilters(filters: MmTaskFilters): MmTaskFilters {
  return {
    formats: filters.formats ? filters.formats.slice() : [],
    regions: filters.regions ? filters.regions.slice() : [],
    clusters: filters.clusters ? filters.clusters.slice() : [],
    groups: explicitIds(filters.groups),
    categories: explicitIds(filters.categories),
    subCategories: explicitIds(filters.subCategories),
  };
}

/** Значения «Все» уровнем не считаются: иначе при выбранной категории покажет «группам (0)» */
export function resolveMonitoringLevel(filters: MmTaskFilters): MmMonitoringLevel {
  if (explicitCount(filters.subCategories) > 0) {
    return 'subcategory';
  }

  if (explicitCount(filters.categories) > 0) {
    return 'category';
  }

  return 'group';
}

export function countOnMonitoringLevel(filters: MmTaskFilters): number {
  const level = resolveMonitoringLevel(filters);

  if (level === 'subcategory') {
    return explicitCount(filters.subCategories);
  }

  if (level === 'category') {
    return explicitCount(filters.categories);
  }

  return explicitCount(filters.groups);
}

export function monitoringLevelLabelKey(level: MmMonitoringLevel): string {
  return 'priceMonitoring.mobileMonitoring.filters.level_' + level;
}

export function resolveTaskMonitoringLevel(
  explicitLevel: string | null,
  classifications: Array<{ subcategoryId: number | null; categoryId: number | null }>,
): MmMonitoringLevel {
  if (explicitLevel === 'subcategory' || explicitLevel === 'category' || explicitLevel === 'group') {
    return explicitLevel;
  }

  let hasSubcategory = false;
  let hasCategory = false;

  for (let i = 0; i < classifications.length; i += 1) {
    const item = classifications[i];

    if (item.subcategoryId !== null && item.subcategoryId !== undefined) {
      hasSubcategory = true;
    }

    if (item.categoryId !== null && item.categoryId !== undefined) {
      hasCategory = true;
    }
  }

  if (hasSubcategory) {
    return 'subcategory';
  }

  if (hasCategory) {
    return 'category';
  }

  return 'group';
}
